import React from "react";
import {
  CurrencyDollarIcon,
  ArrowTopRightOnSquareIcon,
  Cog6ToothIcon,
} from "@heroicons/react/24/outline";
import { useHistory, useLocation } from "react-router-dom";

export default function PricingSetupStep({ onComplete, onSkip }) {
  const history = useHistory();
  const location = useLocation();

  const handleGoToHome = () => {
    history.push("/");
  };

  const isHomePage = location.pathname === "/";

  return (
    <div className="space-y-4">
      {!isHomePage && (
        <div className="bg-green-50 rounded-lg p-4">
          <button
            onClick={handleGoToHome}
            className="w-full bg-white border border-green-200 text-green-800 py-3 px-4 rounded-md text-sm font-medium hover:bg-green-50 transition-colors inline-flex items-center justify-between"
          >
            <div className="flex items-center">
              <Cog6ToothIcon className="h-5 w-5 mr-3" />
              <div className="text-left">
                <div className="font-medium">Go to Pricing Settings</div>
                <div className="text-xs text-green-600">
                  Configure defaults on home page
                </div>
              </div>
            </div>
            <ArrowTopRightOnSquareIcon className="h-4 w-4" />
          </button>
        </div>
      )}

      <div className="bg-gray-50 rounded-lg p-3">
        <h5 className="text-gray-900 text-sm font-medium mb-3">
          Setup Steps:
        </h5>
        <ol className="text-gray-700 text-sm space-y-2">
          <li className="flex items-start">
            <span className="bg-integria-green text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              1
            </span>
            Choose default pricing option
          </li>
          <li className="flex items-start">
            <span className="bg-integria-green text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              2
            </span>
            Set default markup percentage
          </li>
          <li className="flex items-start">
            <span className="bg-integria-green text-white rounded-full w-5 h-5 flex items-center justify-center text-xs font-medium mr-3 mt-0.5 shrink-0">
              3
            </span>
            Save settings
          </li>
        </ol>
      </div>

      <div className="flex space-x-2">
        <button
          onClick={onSkip}
          className="flex-1 border border-gray-300 text-gray-700 py-2 px-4 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors"
        >
          Skip
        </button>
        <button
          onClick={() => {
            onComplete();
            // Use setTimeout to ensure state updates are processed first
            setTimeout(() => {
              history.push("/patients");
            }, 100);
          }}
          className="flex-1 bg-integria-green text-white py-2 px-4 rounded-md text-sm font-medium hover:bg-integria-green/90 transition-colors"
        >
          Done
        </button>
      </div>
    </div>
  );
}
